import store from "../store";

export default {
  getWorkspaceUUID() {
    if (
      (store.getters.isSuperAdmin || store.getters.isAdmin) &&
      !store.getters.getForceWorkspaceFilter
    ) {
      return "";
    } else {
      return sessionStorage.getItem("workspace_uuid") || "";
    }
  },

  getCompanyUUID() {
    return localStorage.getItem("company_uuid") || "";
  },

  getHeaders() {
    return {
      workspaceuuid: this.getWorkspaceUUID(),
      companyuuid: this.getCompanyUUID()
    };
  },

  getPreparedExtras(
    fieldFilters = null,
    fieldsToInclude = null,
    fieldsToAppend = null
  ) {
    let extras = [];
    if (fieldFilters) {
      extras = this.prepareFilters(fieldFilters);
    }
    if (fieldsToInclude && fieldsToInclude !== "") {
      extras.push("include=" + fieldsToInclude);
    }
    if (fieldsToAppend && fieldsToAppend !== "") {
      extras.push("append=" + fieldsToAppend);
    }
    return extras.join("&");
  },

  prepareFilters(filters) {
    return filters.map(
      filter => "filter[" + filter.field + "]=" + filter.value
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/utils.js